const lipoprotein = {
  parameters: [
    {
      name: 'lipoprotein',
      displayName: 'Lipoprotein (a)',
      id: "lipoprotein",
      validFrom: '2025/06/05 1:00',
      validThrough: null,
      interpretationsSupported: [
        'normal',
        'high',
        'fault',
      ],
      ranges: [{
        color: '#1f7359',
        description: 'lipoprotein-normal',
        lowerLimit: 0,
        lowerLimitOperator: '>=',
        upperLimit: 75,
        upperLimitOperator: '<',
        unit: 'nmol/l',
        interpretation: 'normal',
        displayInterpretation: 'Normal',
        rangeInterpretation: '0 - 74',
      },
      {
        color: '#fdad02',
        description: 'lipoprotein-high',
        lowerLimit: 75,
        lowerLimitOperator: '>=',
        upperLimit: 1000,
        upperLimitOperator: '<=',
        unit: 'nmol/l',
        interpretation: 'high',
        displayInterpretation: 'High',
        rangeInterpretation: '>= 75',
      },],
    },
  ],
};

export default lipoprotein;